import { getRoot, resolveIdentifier, types } from 'mobx-state-tree';
import { PharmacyNeighbor } from './PharmacyNeighbor';
import { Pharmacy } from './Pharmacy';
import { Protection } from './Protection';
import { Municipality } from './Municipality';
import { DutyAssignment } from './DutyAssignment';
import { PharmacyStatus } from './PharmacyStatus';

export const PharmacyDetails = types.compose(
  Pharmacy,
  types
    .model('PharmacyDetails', {
      phone: types.maybe(types.string),
      address: types.maybe(types.string),
      zipCode: types.maybe(types.string),
      city: types.maybe(types.string),
      municipalityId: types.maybe(types.integer),
      municipality: types.maybe(Municipality),
      groupId: types.maybe(types.integer),
      // `group` is intentionally NOT declared here: it is provided by the `group`
      // view inherited from Pharmacy (resolved from groupId, or an imperatively
      // assigned override via setGroup). Declaring it as a property collides with
      // that view and corrupts MST snapshots (reportObserved crash on put).
      language: types.string,
      latitude: types.maybe(types.number),
      level: types.maybe(types.integer),
      longitude: types.maybe(types.number),
      zoneId: types.maybe(types.integer),
      receivesSms: types.maybe(types.boolean),
      isContributing: types.boolean,
      density: types.maybe(types.integer),
      minDistance: types.maybe(types.integer),
      maxDistance: types.maybe(types.integer),
      minDistance2: types.maybe(types.integer),
      maxDistance2: types.maybe(types.integer),
      userId: types.maybe(types.integer),
      pharmacyNeighbors: types.optional(types.array(PharmacyNeighbor), []),
      protections: types.optional(types.array(Protection), []),
      anchor: types.maybe(types.string),
      anchorId: types.maybe(types.number),
      distance: types.maybe(types.number),
      prefDutyDayOn: types.maybe(types.string),
      prefDutyDayOff: types.maybe(types.string),
      x: types.maybe(types.number),
      y: types.maybe(types.number),
      transferrableDuties: types.optional(types.array(types.string), []),
      apbLatitude: types.maybe(types.number),
      apbLongitude: types.maybe(types.number),
      apbX: types.maybe(types.number),
      apbY: types.maybe(types.number),
      afmpsX: types.maybe(types.number),
      afmpsY: types.maybe(types.number),
    })
    .views((self) => ({
      neighbors: () => {
        const root: any = getRoot(self);
        const datas = root.PharmacyStore.datas;

        if (!datas) return [];

        return self.pharmacyNeighbors.map((n) => datas.get(n.neighborId)).filter(Boolean);
      },
    })),
);
